import React, { useState, useEffect } from 'react';
import { Button, Container } from 'react-bootstrap';
import CommonTable from '../table/CommonTable';
import { getDataFromServer } from '../../utils/apiBase';
import toast from 'react-hot-toast';
import ContextHelper from '../../ContextHooks/ContextHelper';
import { Delete, Edit } from '@mui/icons-material';
import DeleteModal from '../DeleteModal';
import moment from 'moment';
import { Link, useNavigate } from 'react-router-dom';

const Verifier = () => {
  const { currentUser } = ContextHelper();
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const navigate = useNavigate();

  const columns = [
    { accessor: 'username', label: 'User Name' },
    { accessor: 'type', label: 'Role' },
    { accessor: 'address', label: 'Address' },
    { accessor: 'email', label: 'Email' },
    {
      accessor: 'expiryDate',
      label: 'Expiry Date',
      render: (value) => moment(value).format('DD-MMM-YYYY'),
    },
    {
      accessor: 'actions',
      label: 'Actions',
      render: (value, row) => (
        <div className="d-flex gap-2 flex-wrap">
          <Button variant="outline-success" size="sm" title="Edit" onClick={() => handleEdit(row)}>
            <Edit fontSize="small" />
          </Button>
          <Button variant="outline-danger" size="sm" title="Delete" onClick={() => handleDelete(row.id)}>
            <Delete fontSize="small" />
          </Button>
        </div>
      ),
    },
  ];

  const handleDelete = (id) => {
    setDeleteModal(true);
    console.log('Delete user with ID:', id);
  };

  const fetchUserData = async () => {
    const ApiUrl = 'getUsersOfAdmin';
    const params = {
      end_point: ApiUrl,
      params: { token: currentUser?.token },
      call_back: handleResponse,
      props: '',
    };

    try {
      await getDataFromServer(params);
    } catch (error) {
      console.error('Error fetching verifier data:', error);
      toast.error('Failed to fetch verifier data.');
      setLoading(false);
    }
  };

  const handleResponse = (res) => {
    setLoading(false);
    if (res.status === 'success') {
      const verifiersOnly = res.response.data.filter((user) => user.type?.toLowerCase() === 'verifier');
      setUsers(verifiersOnly.reverse());
    } else {
      toast.error(res.message || 'Failed to fetch verifiers.');
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleEdit = (selectedUser) => {
    navigate('/add-verifier', {
      state: {
        selectedUser: selectedUser,
      },
    });
  };

  return (
    <>
      {deleteModal && (
        <DeleteModal
          deleteModal={deleteModal}
          handleDeleteReport={handleDelete}
          closeModal={() => setDeleteModal(false)}
          loading={loading}
          text={'Verifier'}
        />
      )}

      <Container fluid className="px-0 text-nowrap">
        <div className="bg-white p-md-4 p-2 min-vh-100 shadow-sm position-relative">
          <h3 className="base-color">Verifier Management</h3>
          <div className="position-absolute mt-3 responsive-heading">
            <Link to={'/add-verifier'} className="login-btn base-color-bg text-white px-4 btn text-decoration-none">
              Add Verifier
            </Link>
          </div>
          <CommonTable data={users} columns={columns} loading={loading} />
        </div>
      </Container>
    </>
  );
};

export default Verifier;
